// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"790bb991","424":"78365f7e"}[chunkId] + ".chunk.css";
};